import { defineComponent as _defineComponent } from 'vue'
import viewportEventsService from '@/core/responsive/viewport/viewport-events.service';
import { store } from '@/store';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadMoreWrapper',
  props: {
    lineClampDesktop: { default: 0 },
    lineClampMobile: { default: 0 },
    readMoreLabel: { default: 'Read more' },
    readLessLabel: { default: 'Read less' }
  },
  setup(__props: any) {


const content = ref(null);
const _uid = Math.floor(Math.random() * 1000000).toString();

const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);



const viewportEventIndex = ref<number>();
const isClampedByScreenSize = ref<boolean>(false);
const showAllText = ref<boolean>(false);
const screenSize = ref<string>('');

const className = computed<string>(() => {
    return `line-clamp-${_uid}`;
});

onMounted(() => {
    viewportEventIndex.value = viewportEventsService.setCallback(checkIfClamped);
});

onBeforeUnmount(() => {
    viewportEventsService.removeCallback(viewportEventIndex.value);
});

function checkIfClamped() {
    // Only reset settings on screen resize, not scroll
    const newScreenSize = screenSizeToString(viewportEventsService.viewport);
    if (screenSize.value !== newScreenSize) {
        screenSize.value = newScreenSize;
        isClampedByScreenSize.value = isTextClamped(content.value);
        showAllText.value = false;
    }
}

function toggleShowMore() {
    showAllText.value = !showAllText.value;
}

function screenSizeToString(viewport: { width: number, height: number }) {
    return `${viewport.width}x${viewport.height}`;
}

function isTextClamped(elm: HTMLElement) {
    return elm.scrollHeight > elm.clientHeight;
}

return { __sfc: true,content, _uid, textColor, viewportEventIndex, isClampedByScreenSize, showAllText, screenSize, className, checkIfClamped, toggleShowMore, screenSizeToString, isTextClamped }
}

})